import { Movie} from "../../components/Movie/Movie";
import { TopMovies } from "../../components/TopMovies/TopMovies";
import "./MainPage.scss";

export const MainPage = () => {

  return (
    <>
      <Movie />
      <TopMovies />
    </>
  );
};
